export const INTRO_KEY = 'mantraz_auth_intro';

export function shouldPlayIntro(state) {
  if (!state) return false;
  if (state.routeName !== 'Login') return false;
  return !state.hasSession && !state.alreadyPlayed && !state.reduceMotion;
}

export function loadingWait(minDuration, elapsed) {
  const left = minDuration - elapsed;
  return left > 0 ? left : 0;
}

// sin(pi*t)^2, di luar rentang nol
export function pulseValue(elapsedMs, durationMs) {
  if (!(durationMs > 0)) return 0;
  const t = elapsedMs / durationMs;
  if (t <= 0 || t >= 1) return 0;
  const swell = Math.sin(Math.PI * t);
  return swell * swell;
}

export function introPlayed() {
  try {
    return window.sessionStorage.getItem(INTRO_KEY) === '1';
  } catch (error) {
    return false;
  }
}

export function markIntroPlayed() {
  try {
    window.sessionStorage.setItem(INTRO_KEY, '1');
  } catch (error) { /* mode privat */ }
}
